<template>
  <div class="error-container text-center">
    <div>
      <h1 class="error-number">500</h1>
      <h2 class="semi-bold">Désolé, le serveur rencontre un problème.</h2>
      <p>Essayez de recharger votre page ou <a href="#">signalez le ?</a></p>
    </div>
    <!--<div class="error-container-innner text-center">
      <form lpformnum="1">
        <div class="form-group form-group-default input-group transparent text-left">
          <label>Search</label>
          <input class="form-control" placeholder="Try searching the missing page" type="email">
          <span class="input-group-addon pg-search"></span>
        </div>
      </form>
    </div>-->
  </div>
</template>

<style lang="scss" scoped>
  .error-container {
    width:80%;
    height:calc(100vh - 120px);
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>

<script type="text/babel">
  export default {}
</script>



// WEBPACK FOOTER //
// client/views/ErrorPages/InternalServerError.vue